// extracted by mini-css-extract-plugin
export default {"container":"AiName_container__5+J2e","textarea":"AiName_textarea__ZYj-1","suggestions":"AiName_suggestions__SYQeR","suggestionActive":"AiName_suggestionActive__YJsAe"};